module.exports = __webpack_public_path__ + "img/LK.774482ab.svg";